/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 运维审核类型
 */
let EnumMaintenanceAuditStatus = {
	Audited: 						new EnumItem('审核通过', 1),
	Reject: 						new EnumItem('审核不通过', 2),
    UnAudit: 						new EnumItem('待审核', 0),
	...enumMixn
}
export default EnumMaintenanceAuditStatus
